import { useState, useEffect, useContext } from 'react'
import Button from '@material-ui/core/Button'
import TextField from '@material-ui/core/TextField'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import { StateContext } from '../../context/Provider'
import axiosConfig from '../../utils/axiosConfig'

const ConfirmPasswordModal = (props) => {

    const appState = useContext(StateContext)
    const { authState } = appState
    const {title, message, dialogState, participantId} = props

    const [open, setOpen] = useState(false)

    const handleClose = () => {
        setOpen(false)
        props.closeDialog()
    }

    const [password, setPassword] = useState('')
    const handlePasswordChange = (e) => {
        setPassword(e.target.value)
        if (password != '') {
            setPasswordError(false)
        }
    }

    const [passwordError, setPasswordError] = useState(false)

    const handleConfirm = async () => {
        if (password == '') {
            setPasswordError('Password field is required')
            return
        }

        const response = await axiosConfig.post('/confirm-password', {
            email: authState.user.email,
            password: password
        });

        if (response.status === 200) {
            if (response.data.confirmed == true) {
                props.dialogConfirmed(participantId)
            }else{
                setPasswordError(response.data.message)
            }
        } else {
            console.log(response)
        }
    }

    useEffect(() => {
        console.log('Password confirmation rendered')
        setOpen(dialogState)
        setPassword('')
    }, [dialogState])

    return (
        <div>
            <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
                <DialogTitle id="form-dialog-title">{title}</DialogTitle>
                <DialogContent>
                <DialogContentText>
                    {message}
                </DialogContentText>
                <TextField
                    autoFocus
                    margin="dense"
                    id="password"
                    label="Password"
                    type="password"
                    onChange={handlePasswordChange}
                    fullWidth
                    error={passwordError != ""}
                    helperText={passwordError}
                />
                </DialogContent>
                <DialogActions>
                <Button onClick={handleClose} color="primary">
                    Cancel
                </Button>
                <Button onClick={handleConfirm} color="primary">
                    Confirm
                </Button>
                </DialogActions>
            </Dialog>
        </div>
    )

}

export default ConfirmPasswordModal